import { render, staticRenderFns } from "./TableStockoutChangesOldStock.vue?vue&type=template&id=f04c5fcc&scoped=true&"
import script from "./TableStockoutChangesOldStock.vue?vue&type=script&lang=js&"
export * from "./TableStockoutChangesOldStock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f04c5fcc",
  null
  
)

export default component.exports